import { Link } from "react-location";

import './Presentation.scss';

export const Presentation = ({ alt, buttons, classSuffix, description, image, title, subtitle }) => (
  <div className={`presentation presentation--${classSuffix}`}>
    <div className="presentation__text-content">
      <h1>{title}</h1>
      {subtitle && <h2>{subtitle}</h2>}
      {description &&
        <div className="presentation__description">
          <p dangerouslySetInnerHTML={{ __html: description }} />
        </div>
      }

      {buttons &&
        <div className="presentation__buttons">
          {buttons.map((button) => {
            if (button.linkType === "internal") {
              return (
                <Link className={`button button__${button.type}`} key={button.link} to={button.link}>
                  {button.text}
                </Link>
              )
            } else {
              return (
                <a className={`button button__${button.type}`} key={button.link} href={button.link}>
                  {button.text}
                </a>
              )
            }
          })}
        </div>
      }
      <div className="presentation__image">
        <img alt={alt} src={image} />
      </div>
    </div>
  </div>
)

export default Presentation;